import { Box } from "@mui/material";
import { noop } from "lodash-es";
import { useMemo, useState } from "react";

import { DamageDetectionItemViewModal } from "@/common/components/Entity/DamageDetection/DamageDetectionItemViewModal";
import { Mapper } from "@/common/mapping/mapper";
import { DamageDetectionDto, DamageDetectionItemDto } from "@/core/api/generated/v1";

import {
  GenericDamageViewerMode,
  VisualModelEditorOfGenericDamage,
} from "../GenericDamage/VisualModelEditorOfGenericDamage";

interface Props {
  entity: DamageDetectionDto;
}

export function VisualModelViewerOfDamageDetection({ entity }: Props) {
  const [itemToView, setItemToView] = useState<Nil<DamageDetectionItemDto>>(null);

  const genericDamages = useMemo(
    () =>
      entity.items?.map((x) =>
        Mapper.visualModel.mapDamageDetectionItemToGenericDamage(x, {
          visualModelId: entity.vehicleVisualModel?.id,
        }),
      ) || [],
    [entity],
  );

  return (
    <Box>
      {entity.vehicle?.id && (
        <VisualModelEditorOfGenericDamage
          mode={GenericDamageViewerMode.View}
          vehicleId={entity.vehicle.id}
          visualModelId={entity.vehicleVisualModel?.id}
          visualModel={undefined}
          isAutoPickVisualModel={false}
          damages={genericDamages}
          isDisplayOld
          isDisplayList={false}
          isViewOldEnabled
          isViewEnabled
          oldDamagesDisplay={{
            defaultStates: [],
            isStateTogglesEnabled: true,
          }}
          onView={(damage) => {
            setItemToView(damage.data);
          }}
          onCreated={noop}
          onUpdated={noop}
          onDeleted={noop}
          onManyChanged={noop}
        />
      )}

      {/* Item view */}
      {itemToView && (
        <DamageDetectionItemViewModal
          open={!!itemToView}
          onClose={() => {
            setItemToView(null);
          }}
          viewProps={{
            damageDetection: entity,
            item: itemToView,
          }}
        />
      )}
    </Box>
  );
}
